import AccessControlLayout from '../layouts/AccessControlLayout';
import ErrorPage from '../pages/ErrorPage';
import ProjectsLayout from '../layouts/Projects';
import ViewerLayout from '../layouts/Viewer';
import ProjectsHome from '../pages/projects/ProjectsHome';
import ProjectsManage from '../pages/projects/ProjectsManage';
import ProjectDetail from '../pages/projects/ProjectDetail';
import ProjectHomepage from '../pages/projects/ProjectHomepage';
import ProjectProgressPage from '../pages/projects/ProjectProgressPage';
import ProjectSurveyPage from '../pages/projects/ProjectSurveyPage';
import ProjectViewer from '../pages/projects/ProjectViewer';
import ProjectReviewViewer from '../pages/projects/ProjectReviewViewer';
import OrganizationHome from '../pages/projects/OrganizationHome';
import SlideSetViewer from '../pages/projects/SlideSetViewer';
import SlideSetLanding from '../pages/projects/SlideSetLanding';

// Routes without an item in the URL use folderId (or no id) for access control.
const ProjectsRoutes = {
    element: <AccessControlLayout isPublic={false} useBaseLayout={true} />,
    errorElement: <ErrorPage />,
    children: [{
        element: <ProjectsLayout />,
        children: [
            { path: '/projects', element: <ProjectsHome /> },
            // Browse and organize (folder hierarchy); left nav label matches UX copy.
            { path: '/projects/manage', element: <ProjectsManage /> },
            { path: '/projects/manage/:folderId', element: <ProjectsManage /> },
            // Canonical org landing by folder name (must be before /projects/:folderId).
            { path: '/projects/org/:orgName', element: <OrganizationHome /> },
            // /projects/:folderId/participate must appear before /projects/:folderId
            // so "participate" is not consumed as a folder ID segment.
            { path: '/projects/:folderId/participate', element: <ProjectHomepage /> },
            // /projects/:folderId/survey/:surveyType must appear before /projects/:folderId
            { path: '/projects/:folderId/survey/:surveyType', element: <ProjectSurveyPage /> },
            // /projects/:folderId/progress must appear before /projects/:folderId
            // so "progress" is not consumed as a folder ID segment.
            { path: '/projects/:folderId/progress', element: <ProjectProgressPage /> },
            { path: '/projects/:folderId', element: <ProjectDetail /> },
        ]
    }]
};

// The viewer route has both :folderId and :itemId. We check access against the
// project folder — all items in a project share the folder's ACL (propagated
// recursively by _sync_participant_access). Checking folderId means the access
// query key stays stable as the user navigates between items in the same project,
// avoiding a full-page re-render on every item change.
// If per-item access grants are ever introduced, this will need revisiting.
const ProjectViewerRoutes = {
    element: <AccessControlLayout isPublic={false} useBaseLayout={true} checkParam="folderId" />,
    errorElement: <ErrorPage />,
    children: [{
        element: <ViewerLayout />,
        children: [
            // /projects/:folderId/view/:itemId — must be a separate route group
            // from ProjectsRoutes because AccessControlLayout needs checkParam here.
            { path: '/projects/:folderId/view/:itemId', element: <ProjectViewer /> },
            // /projects/:folderId/roi-edit/:itemId — admin ROI layer editor (ProjectViewer mounts bbox stack when eligible).
            { path: '/projects/:folderId/roi-edit/:itemId', element: <ProjectViewer /> },
            // /projects/:folderId/review/:itemId — admin review viewer with overlays.
            { path: '/projects/:folderId/review/:itemId', element: <ProjectReviewViewer /> },
        ]
    }]
};

// Public-capable Slide Set routes: layout skips Girder folder ACL probe so
// anonymous users can reach public Slide Sets; the page enforces via projects API.
const SlideSetPublicRoutes = {
    element: <AccessControlLayout isPublic={true} useBaseLayout={true} />,
    errorElement: <ErrorPage />,
    children: [
        { path: '/slidesets/:folderId', element: <SlideSetLanding /> },
        {
            element: <ViewerLayout />,
            children: [
                { path: '/slidesets/:folderId/view/:itemId', element: <SlideSetViewer /> },
            ],
        },
    ],
};

const AllProjectsRoutes = [ProjectsRoutes, ProjectViewerRoutes, SlideSetPublicRoutes];

export default AllProjectsRoutes;
